import { render, staticRenderFns } from "./EntranceInfo.vue?vue&type=template&id=62c39ff8&"
import script from "./EntranceInfo.vue?vue&type=script&lang=js&"
export * from "./EntranceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports